<!-- <div class="component"> -->
<div class="bookmarkgroups" cdkDropListGroup>
  @for (bookmarkGroup of bookmarks.bookmarkGroup$ | async | keyvalue; track $index) {
    <div class="bookmarkgroup">
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>{{ bookmarkGroup.value.Description }}</mat-panel-title>
          <button
            type="button"
            class="icon-button"
            (click)="$event.stopImmediatePropagation(); deleteGroup(bookmarkGroup.value)"
            [attr.aria-label]="'BOOKMARKS.BUTTON.DELETE_GROUP' | translate"
          >
            <mat-icon>delete</mat-icon>
          </button>
          <button
            type="button"
            class="icon-button"
            (click)="$event.stopImmediatePropagation(); editGroup(bookmarkGroup.value)"
            [attr.aria-label]="'BOOKMARKS.BUTTON.EDIT_GROUP' | translate"
          >
            <mat-icon>edit</mat-icon>
          </button>
        </mat-expansion-panel-header>
        <ul class="bookmarks custom-scroll" cdkDropList (cdkDropListDropped)="drop($event)" [cdkDropListData]="bookmarkGroup.value">
          @for (bookmark of bookmarkGroup.value.bookmarks; track $index) {
            <li class="bookmark" cdkDrag>
              <a [routerLink]="bookmark.link" class="link">
                <div class="title">
                  <span class="description">{{ bookmark.Description }}</span>
                  <span class="workspace">{{ bookmark.workspace }} | {{ bookmark.role }}</span>
                </div>
              </a>
              <ul class="actions">
                <li>
                  <button type="button" class="icon-button" (click)="deleteBookmark(bookmark)" [attr.aria-label]="'BOOKMARKS.BUTTON.DELETE' | translate">
                    <mat-icon>delete</mat-icon>
                  </button>
                </li>
                <li>
                  <button type="button" class="icon-button" (click)="editBookmark(bookmark)" [attr.aria-label]="'BOOKMARKS.BUTTON.EDIT' | translate">
                    <mat-icon>edit</mat-icon>
                  </button>
                </li>
                <li>
                  <button type="button" class="icon-button drag" cdkDragHandle [attr.aria-label]="'BOOKMARKS.BUTTON.DRAG' | translate">
                    <mat-icon>drag_indicator</mat-icon>
                  </button>
                </li>
              </ul>
            </li>
          }
        </ul>
      </mat-expansion-panel>
    </div>
  }
</div>
<!-- </div> -->
